<div class="buttons-container">
  <button
    class="buttons-accept button"
    puButton
    uiType="secondary"
    (click)="acceptEmitter.emit()"
  >
    <pu-icon
      iconName="check"
      size="16"

    />
  </button>

  <button
    class="buttons-decline button"
    puButton
    uiType="secondary"
    (click)="declineEmitter.emit()"
  >
    <pu-icon
      iconName="close"
      size="12"
    />
  </button>

</div>
